<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <form #basicForm="ngForm">
    <div class="display-flex form-row flex-items-centered">
      <div class="flex-grow-1">
        <div class="merlin-control">
          <div class="label-cont">
            <label class="mer-label">Comments</label>
          </div>
          <div class="control-cont">
            <textarea rows="3" class="mer-text-field mer-textarea" name="notes" [(ngModel)]="comments">
        </textarea>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions class="display-flex">
  <div class="flex-grow-1"></div>
  <button class="main-btn empty-back-btn margin-m" [mat-dialog-close]="false">CANCEL</button>
  <button class="main-btn filled-back-btn" (click)="updateDevice()" cdkFocusInitial [disabled]="basicForm.invalid">OK</button>
</div>
